"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MATCH_AUTH_STATE_KEY = void 0;
// regex to match auth state keys
var MATCH_AUTH_STATE_KEY = /^auth-sc-[0-9]*-[a-zA-Z0-9]*$/g; // function to tell us if a string is an auth state key

exports.MATCH_AUTH_STATE_KEY = MATCH_AUTH_STATE_KEY;
var isStringAuthStateKey = function isStringAuthStateKey(string) {
  return MATCH_AUTH_STATE_KEY.test(string);
};
var _default = isStringAuthStateKey;
exports.default = _default;